import React from 'react';
import { Sparkles, ListChecks, Wallet, CalendarClock, RefreshCw } from 'lucide-react';
import FadeIn from './FadeIn';

const groceryItems = [
  'Rice (5kg)',
  'Milk × 4',
  'Eggs × 30',
  'Cooking Oil',
  'Onions (2kg)',
  'Tomatoes',
  'Dal × 3',
];

const upcomingFeatures = [
  { icon: Sparkles, label: 'AI grocery assistant' },
  { icon: ListChecks, label: 'Smart grocery list creation' },
  { icon: Wallet, label: 'Budget planning tools' },
  { icon: CalendarClock, label: 'Delivery scheduling' },
  { icon: RefreshCw, label: 'Subscription grocery ordering' },
];

export default function AppPreview() {
  return (
    <section className="section-spacing bg-muted/40">
      <div className="content-width-wide">
        <FadeIn>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground tracking-tight">
            The Future of Smart Grocery Management
          </h2>
        </FadeIn>
        <FadeIn delay={0.1}>
          <p className="mt-4 text-muted-foreground text-lg leading-relaxed">
            The One Click Essentials mobile app is launching soon on Android &amp; iOS.
          </p>
        </FadeIn>

        <div className="mt-12 flex flex-col md:flex-row gap-12 md:gap-16 items-center">
          {/* Phone mockup */}
          <FadeIn direction="right" className="flex-shrink-0">
            <div className="w-56 h-96 bg-foreground rounded-[2rem] p-3 shadow-2xl shadow-foreground/10">
              <div className="w-full h-full bg-background rounded-[1.4rem] flex flex-col overflow-hidden">
                <div className="bg-primary/10 px-4 py-3">
                  <div className="h-2 w-16 bg-primary/20 rounded-full"></div>
                </div>
                <div className="flex-1 px-4 py-4 space-y-3">
                  {groceryItems.map((item, i) => (
                    <div key={i} className="flex items-center gap-2">
                      <div className="h-3.5 w-3.5 rounded border-2 border-primary/30 flex-shrink-0"></div>
                      <span className="text-xs text-foreground">{item}</span>
                    </div>
                  ))}
                </div>
                <div className="px-4 pb-4">
                  <div className="bg-primary text-primary-foreground text-xs text-center py-2 rounded-lg font-medium">
                    Send List
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>

          {/* Upcoming features */}
          <div className="space-y-4 pt-2">
            <FadeIn>
              <p className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
                Upcoming Features
              </p>
            </FadeIn>
            {upcomingFeatures.map(({ icon: Icon, label }, i) => (
              <FadeIn key={i} delay={0.1 + i * 0.08}>
                <div className="flex items-center gap-3 text-foreground">
                  <span className="flex items-center justify-center h-8 w-8 rounded-lg bg-secondary">
                    <Icon className="h-4 w-4 text-primary" strokeWidth={1.5} />
                  </span>
                  <span className="text-base">{label}</span>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
